import { FormikProps } from 'formik'

import { components } from './customer.schema'

import { CustomerSegment } from '~/basket/model/common/segment.model'

export type FetchClientSearchRequest = components['schemas']['CustomerSearchRequest']
export type FetchClientSearchResponseData = components['schemas']['CustomerSearchResponse']

export type GenericError = { message?: string; code?: string; status?: string; detailMsg?: string }

export enum DocType {
  NIF = 'NIF',
  NIE = 'NIE',
  CIF = 'CIF',
  PASS = 'PASS',
}

interface CustomerExtra {
  isValid?: boolean
}
export interface Customer extends CustomerExtra {
  name: string
  firstName: string
  lastName?: string
  docType: string
  docId: string
  nationality: string
  contactPhone: string | undefined
  companyName?: string
  cif?: string
  customerSegment: CustomerSegment | string
  birthdate?: Date | null
  email: string
  language: string
  technology: string
  province?: {
    id: string
    value: string
  } | null
  gender?: string
}

export type CustomerFormModel = Omit<Customer, 'email' | 'language' | 'technology' | 'docType'>

export interface CustomerFormProps extends FormikProps<CustomerFormModel> {
  isCompanySegment: boolean
  docType: string
}

export interface CustomerInfoFormProps {
  docType: string
  isCompanySegment: boolean
}
